export const selectWatchlist = state => state.watchlist;
